import {
  PASSWORD,
  CONFIRM_PASSWORD,
  PASSWORD_INVALID,
  PASSWORD_REQUIRED,
  CONFIRM_PASSWORD_REQUIRED,
  PASSWORDS_NOT_MATCHING,
  FIRST_NAME,
  LAST_NAME,
} from "constants/registrationForm";
import { isEmptyObj } from "utils/isEmptyObj";
import {
  validatePassword,
  checkSpace,
  nameCheckPassword,
  emailCheckPassword,
  isEmpty,
} from "@jsainsburyplc/id-ui-common";

const validate = ({ email }, values) => {
  const errors = {};
  const password = values[PASSWORD];
  const confirmPassword = values[CONFIRM_PASSWORD];

  let passwordValid =
    validatePassword(password) &&
    checkSpace(password) &&
    !emailCheckPassword(password, email) &&
    !nameCheckPassword(password, values[FIRST_NAME]) &&
    !nameCheckPassword(password, values[LAST_NAME]);

  if (isEmpty(password)) {
    errors[PASSWORD] = PASSWORD_REQUIRED;
  } else if (!passwordValid) {
    errors[PASSWORD] = PASSWORD_INVALID;
  }

  if (isEmpty(confirmPassword)) {
    errors[CONFIRM_PASSWORD] = CONFIRM_PASSWORD_REQUIRED;
  } else if (values[PASSWORD] !== values[CONFIRM_PASSWORD]) {
    errors[CONFIRM_PASSWORD] = PASSWORDS_NOT_MATCHING;
  }

  return isEmptyObj(errors) ? {} : errors;
};

export default validate;
